import {
  Component,
  Output,
  EventEmitter,
  Input,
  OnInit,
  HostBinding,
  ChangeDetectorRef,
} from '@angular/core';
import { OfferType } from 'src/app/shared/enums/offer-type.enum';
import { SettingsDataService } from 'src/app/shared/services/communication_services/settingsData.service';
import { OfferData } from 'src/app/shared/types/offer-data.interface';
import { environment } from 'src/environments/environment';
import { BuildVersion } from 'src/environments/environment-model.interface';

@Component({
  selector: 'app-subscriptions-paywall2025-2-offer',
  templateUrl: './paywall2025-2.component.html',
  styleUrls: ['./paywall2025-2.component.scss'],
})
export class SubscriptionsPaywall2025_2TemplateComponent implements OnInit {
  @Input() public subscriptionOffers: OfferData[];
  @Input()
  @HostBinding('class.is-modal')
  public isModal = false;

  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() public close = new EventEmitter();
  @Output() public openPolicy = new EventEmitter();
  @Output() public openTerms = new EventEmitter();
  @Output() public onPurchase = new EventEmitter<OfferData>();

  public subscriptions: OfferData[] = [];

  public selectedSubscription: OfferData;

  public readonly environment = environment;
  public readonly buildVersion = BuildVersion;
  public readonly offerType = OfferType;

  constructor(
    private _settingsDataService: SettingsDataService,
    private _changeDetection: ChangeDetectorRef,
  ) {}

  public ngOnInit(): void {
    this.subscriptions.push(
      this.subscriptionOffers.find(
        (o) => o.type === OfferType.weeklySubscription,
      ),
      this.subscriptionOffers.find(
        (o) => o.type === OfferType.monthlySubscription,
      ),
      this.subscriptionOffers.find(
        (o) => o.type === OfferType.yearlySubscription,
      ),
    );

    this.selectedSubscription = this.subscriptions[1] ?? this.subscriptions[0];
  }

  public selectSubscription(subscription: OfferData): void {
    this.selectedSubscription = subscription;
  }

  public purchase() {
    this.onPurchase.emit(this.selectedSubscription);
  }
}
